var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.showCurrentState)?_c('span',[_c('kbd',[_vm._v(_vm._s(_vm.normBefore))]),_vm._v(" → ")]):_vm._e(),_c('kbd',[_vm._v(_vm._s(_vm.normAfter))])])
}
var staticRenderFns = []

export { render, staticRenderFns }